export default {
    "fr": {
        "My notifications": "Mes notifications",
        "Share notifications": "Partage des notifications aux autres comptes",
        "Your notifications are up to date": "Vos notifications ont été mises à jour",
        "document_added": "Nouveau document ajouté",
        "message_added": "Nouveau message ajouté",
        "mission_created": "Nouvelle mission crée",
        "mission_started": "Mission démarrée",
        "mission_achieved": "Mission terminée",
        "cross_channel_boarding": "Embarquement transmanche",
        "additional_costs": "Coûts additionnels",
        "dsce": "DSCE validé ou demandé",
        "newsletter": "Newsletter",
        "compliant_document": "Document conforme",
        "declaration_ready": "Déclaration prête",
        "douane_status": "Statut douanier"
    },
    "en": {
        "My notifications": "My notifications",
        "Share notifications": "Sharing notifications with other accounts",
        "Your notifications are up to date": "Your notifications are up to date",
        "document_added": "Document added",
        "message_added": "Message added",
        "mission_created": "Mission created",
        "mission_started": "Mission started",
        "mission_achieved": "Mission achieved",
        "cross_channel_boarding": "Cross channel Boarding",
        "additional_costs": "Additional costs",
        "dsce": "CHED validated or requested",
        "newsletter": "Newsletter",
        "compliant_document": "Compliant document",
        "declaration_ready": "Declaration ready",
        "douane_status": "Customs status"
    }
}
